// src/components/DynamicIsland/TickerBand.jsx
import React, { useState, useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";
import CloseIcon from "@mui/icons-material/Close";
import {
  modelIcons,
  actionIcons,
  actionLabels,
  modelLabels,
  logCategoryIcons,
  categoryLabels,
} from "../../IconMaps";
import { ActionType } from "../../Enums.js";
import "./TickerBand.css";

const MARQUEE_BASE_SPEED = 50; // Base speed for marquee; calibrate if needed

const formatTickerText = ({ recordType, action, model, text }) => {
  if (recordType === "Logs") {
    const catIcon = logCategoryIcons[action] || actionIcons[action];
    const catLabel = categoryLabels[action] || actionLabels[action];

    //console.log("catIcon:", catIcon, "catLabel:", catLabel);

    return (
      <>
        <span className="model-icon">{modelIcons[model]}</span>
        <span className="model-text">{modelLabels[model]}</span>
        <strong className="action-text">{catLabel}</strong>
        <span className="action-icon">{catIcon}</span>
        {text && <span className="message-text">- {text}</span>}
      </>
    );
  }

  if (action === ActionType.INSERT) {
    return (
      <>
        <span className="action-icon">{actionIcons[action]}</span>
        <span className="action-text">{actionLabels[action]}</span>
        <span className="model-icon">{modelIcons[model]}</span>
        <span className="model-text">{modelLabels[model]}</span>
        {text && <span className="message-text">: {text}</span>}
      </>
    );
  }

  return (
    <>
      <span className="model-icon">{modelIcons[model]}</span>
      <span className="model-text">{modelLabels[model]}</span>
      <span className="action-icon">{actionIcons[action]}</span>
      <span className="action-text">{actionLabels[action]}</span>
      {text && <span className="message-text">: {text}</span>}
    </>
  );
};

export default function TickerBand({
  items = [],
  speed = 1,
  onClose,
  onCycleComplete,
}) {
  // restart control: remount when transitioning from closed -> open
  const [restartKey, setRestartKey] = useState(0);
  const wasOpenRef = useRef(false);
  const isOpen = items.length > 0;

  useEffect(() => {
    if (isOpen && !wasOpenRef.current) {
      setRestartKey((k) => k + 1);
    }
    wasOpenRef.current = isOpen;
  }, [isOpen]);

  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div className={`ticker-band-content ${isOpen ? "open" : ""}`}>
      <div className="ticker-close-wrapper">
        <button className="ticker-close-btn" onClick={handleClose}>
          <CloseIcon fontSize="small" sx={{ color: "white" }} />
        </button>
      </div>

      {isOpen && (
        <Marquee
          key={restartKey}
          speed={speed * MARQUEE_BASE_SPEED}
          pauseOnHover={true}
          gradient={false}
          onCycleComplete={() => {
            if (typeof onCycleComplete === "function") {
              onCycleComplete();
            }
          }}
        >
          {items.map((msg) => (
            <div className="ticker-item" key={msg.id}>
              {formatTickerText(msg)}
            </div>
          ))}
        </Marquee>
      )}
    </div>
  );
}
